import "./carousel-styles.css";
import { CustomCarousel, ProjectsContainer, ProjectsSection } from "./styles";
import ProjectComponent from "./ProjectComponent";

import { useEffect, useState } from "react";
import { projects } from "./projects-data";

interface IProjectPageProps {
  page: number;
}

const ProjectsPage = ({ page }: IProjectPageProps) => {
  const [isHidden, setIsHidden] = useState<"l" | "cl" | "cr" | "r">("r");

  console.log(isHidden + " ");

  useEffect(() => {
    if (page === 1) {
      setTimeout(
        () =>
          setIsHidden((oldValue) => {
            return ("c" + oldValue) as "l" | "cl" | "cr" | "r";
          }),
        500
      );
    }
    if (page < 1) {
      setTimeout(() => setIsHidden("r"), 1000);
    }
    if (page > 1) {
      setTimeout(() => setIsHidden("l"), 1000);
    }
  }, [page]);

  return (
    <ProjectsSection>
      <div className="container">
        <h2>Project showcase</h2>
        <ProjectsContainer
          className={
            (isHidden[0] === "c" &&
              (isHidden[1] === "l" ? "showL" : "showR")) ||
            ""
          }
        >
          <CustomCarousel infiniteLoop showThumbs={false}>
            {projects.map((project, idx) => (
              <ProjectComponent key={idx} project={project} />
            ))}
          </CustomCarousel>
        </ProjectsContainer>
      </div>
    </ProjectsSection>
  );
};

export default ProjectsPage;
